module.exports = __webpack_public_path__ + "static/blog5-b6f14a1102975a46262114d624f05ec7.png";